export default [
  { key: 0, label: '简体中文', value: 'zh-CN', currency: '元', money: '￥' },
  // { key: 0, label: '繁體中文', value: 'zh-HK', currency: '港元', money: 'HK$' },
  { key: 1, label: 'English', value: 'en-US', currency: 'dollar', money: '$' },
  { key: 2, label: 'Australian', value: 'en-AU', currency: 'EUR', money: 'ES' }
]
